import { types } from "../../types/types";
import { TIPO_PRACTICAS_POR_FECHA } from "../../utils/constants";

const initialState = {
  capitulos: [],
  dataPrevisualizacion: [],
  practicasConfirmadas: [],
  valorFijoPracticasTabla: [],
  valorFijoPracticasActivas: [],
  nnxPracticasTabla: [],
  nnxPracticasActivas: [],
  nbuPracticasTabla: [],
  nbuPracticasActivas: [],
  modulosActivos: [],
  modulosTabla: [],
  presupuestos: [],
  conveniosPorPractica: [],
  equivalenciasNomencladores: [],
  //filtros para los activos
  activosPorFecha: TIPO_PRACTICAS_POR_FECHA.VIGENTES,
  loading: false
};

export const contratacionesConveniosReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.contratacionesConveniosGetPorPracticaSuccess:
      return {
        ...state,
        conveniosPorPractica: action.payload,
      };
    case types.contratacionesConveniosGetPorPracticaError:
      return {
        ...state,
        conveniosPorPractica: [],
      };
    case types.contratacionesConveniosTraerCapitulos:
      return {
        ...state,
        capitulos: action.payload,
      };
    case types.contratacionesConveniosPrevisualizacionSuccess:
      return {
        ...state,
        dataPrevisualizacion: action.payload,
      };
    case types.contratacionesConveniosPrevisualizacionError:
      return {
        ...state,
        dataPrevisualizacion: [],
      };
    case types.contratacionesConveniosGetPracticasConfirmadasSuccess:
      return {
        ...state,
        practicasConfirmadas: action.payload,
      };
    case types.contratacionesConveniosGetPracticasConfirmadasError:
      return {
        ...state,
        practicasConfirmadas: [],
      };
    case types.contratacionesConveniosValorFijoGetPracticasSuccess:
      return {
        ...state,
        valorFijoPracticasTabla: action.payload,
      };
    case types.contratacionesConveniosValorFijoGetPracticasError:
      return {
        ...state,
        valorFijoPracticasTabla: [],
      };
    case types.contratacionesConveniosValorFijoGetPracticasActivasSuccess:
      return {
        ...state,
        valorFijoPracticasActivas: action.payload,
      };
    case types.contratacionesConveniosValorFijoGetPracticasActivasError:
      return {
        ...state,
        valorFijoPracticasActivas: [],
      };
    case types.contratacionesConveniosNNXGetPracticasSuccess:
      return {
        ...state,
        nnxPracticasTabla: action.payload,
      };
    case types.contratacionesConveniosNNXGetPracticasError:
      return {
        ...state,
        nnxPracticasTabla: [],
      };
    case types.contratacionesConveniosNNXGetPracticasActivasSuccess:
      return {
        ...state,
        nnxPracticasActivas: action.payload,
      };
    case types.contratacionesConveniosNNXGetPracticasActivasError:
      return {
        ...state,
        nnxPracticasActivas: [],
      };
    case types.contratacionesConveniosNBUGetPracticasSuccess:
      return {
        ...state,
        nbuPracticasTabla: action.payload,
      };
    case types.contratacionesConveniosNBUGetPracticasError:
      return {
        ...state,
        nbuPracticasTabla: [],
      };
    case types.contratacionesConveniosNBUGetPracticasActivasSuccess:
      return {
        ...state,
        nbuPracticasActivas: action.payload,
      };
    case types.contratacionesConveniosNBUGetPracticasActivasError:
      return {
        ...state,
        nbuPracticasActivas: [],
      };
    case types.contratacionesConveniosModulosCargaSuccess:
      return {
        ...state,
        modulosTabla: action.payload,
      };
    case types.contratacionesConveniosModulosCargaError:
      return {
        ...state,
        modulosTabla: [],
      };
    case types.contratacionesConveniosModulosGetActivosSuccess:
      return {
        ...state,
        modulosActivos: action.payload,
      };
    case types.contratacionesConveniosModulosGetActivosError:
      return {
        ...state,
        modulosActivos: [],
      };
    case types.contratacionesConveniosPresupuestosGetActivosSuccess:
      return {
        ...state,
        presupuestos: action.payload,
      };
    case types.contratacionesConveniosPresupuestosGetActivosError:
      return {
        ...state,
        presupuestos: [],
      };
    case types.contratacionesConveniosEquivalenciasNomencladoresGetSuccess:
      return {
        ...state,
        equivalenciasNomencladores: action.payload,
      };
    case types.contratacionesConveniosEquivalenciasNomencladoresGetError:
      return {
        ...state,
        equivalenciasNomencladores: [],
      };
    case types.contratacionesContratoLimpiarSeleccion: {
      return {
        ...initialState
      };
    }
    case types.contratacionesContratoLimpiarConvenios: {
      return {
        ...initialState
      };
    }
    case types.contratacionesConveniosSetActivosPorFecha: {
      return {
        ...state,
        activosPorFecha: action.payload
      }
    }
    default:
      return state;
  }
};
